
import { CardContent } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";

interface JobDescriptionProps {
  description: string;
  skills: string[];
  keyResponsibilities?: string;
}

export const JobDescription = ({ description, skills, keyResponsibilities }: JobDescriptionProps) => (
  <CardContent className="space-y-6">
    <div className="space-y-4">
      <h2 className="text-xl font-semibold text-foreground">About the Role</h2>
      <div 
        className="text-muted-foreground leading-relaxed" 
        dir="ltr" 
        style={{ textAlign: 'left' }}
        dangerouslySetInnerHTML={{ __html: description }}
      />
    </div>

    {keyResponsibilities && (
      <div className="space-y-4">
        <h2 className="text-xl font-semibold text-foreground">Key Responsibilities</h2>
        <div 
          className="text-muted-foreground leading-relaxed"
          dir="ltr"
          style={{ textAlign: 'left' }}
          dangerouslySetInnerHTML={{ __html: keyResponsibilities }}
        />
      </div>
    )}

    <div className="space-y-4">
      <h2 className="text-xl font-semibold text-foreground">Required Skills</h2>
      <div className="flex flex-wrap gap-2">
        {skills?.map((skill: string) => (
          <Badge 
            key={skill} 
            variant="outline"
            className="px-3 py-1 rounded-full border-2 border-blue-sky text-blue-sky bg-transparent hover:bg-blue-sky/10"
          >
            {skill}
          </Badge>
        ))}
      </div>
    </div>
  </CardContent>
);
